import View from './View.js';
import bindData from './Data.js';

const Index9 = bindData(View);
export default Index9;
